/**
 * Como os números aparecem para quem lê em português.
 *
 * **O SEPARADOR DECIMAL É VÍRGULA.** `toFixed()` devolve o formato inglês —
 * `US$ 18.42`, `21.3 por dia` —, e num painel em pt-BR isso não é detalhe de
 * gosto: `US$ 17.630` é lido como dezessete mil e seiscentos, quando o valor é
 * dezessete e sessenta e três. O desenho aprovado usa vírgula em toda parte.
 *
 * `Intl` faz o trabalho e conhece as regras; o que fica aqui é a escolha de
 * quantas casas cada grandeza merece.
 */

/** Dinheiro em dólar, o que o provedor cobra. Duas casas, como numa fatura. */
export function dolar(valor: number, casas = 2): string {
  return `US$ ${valor.toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  })}`
}

/**
 * O custo de UMA execução, que é de centavos.
 *
 * Duas casas o arredondariam para `US$ 0,02` e esconderiam a diferença entre
 * duas chamadas — aqui as três casas são informação, não precisão decorativa.
 */
export function dolarMiudo(valor: number): string {
  return dolar(valor, 3)
}

/** Um número com casa decimal só quando ela diz alguma coisa. */
export function numero(valor: number, casas = 1): string {
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  })
}

/** Inteiro com separador de milhar: 4.628, não 4628. */
export function inteiro(valor: number): string {
  return valor.toLocaleString('pt-BR')
}

/**
 * Contagem grande, encurtada — 4,1 M em vez de 4.100.000.
 *
 * O painel mostra tokens na casa dos milhões, e o número inteiro rouba a
 * atenção do que está ao lado sem dizer mais nada.
 */
export function milhares(valor: number): string {
  if (valor >= 1_000_000) return `${numero(valor / 1_000_000)} M`
  if (valor >= 1_000) return `${numero(valor / 1_000)} mil`
  return inteiro(valor)
}
